export default [
  'addChildCompany',
  'addParentCompany',
  'removeChildCompany',
  'removeParentCompany',
  'viewCompanyHierarchy'
]
